import { UserDetail } from 'types'
import { createRequestInstance } from '../'

const ME_URL = import.meta.env.VITE_SSO_ME_URL || ''
const USER_DETAIL_URL = import.meta.env.VITE_USER_DETAIL_URL

const request = createRequestInstance({})

type FetchUserResponse = {
  userId: string
  firstName: string
  lastName: string
  email: string
  adddress?: string
  city?: string
}

export async function fetchUser() {
  const response = await request.get<FetchUserResponse>(ME_URL)
  const { data } = response
  const { userId, firstName, lastName, email } = data

  return {
    id: Number(userId),
    firstName,
    lastName,
    email,
  }
}

export async function fetchUserDetail(
  userId: number | string,
  expandCertifications?: boolean,
): Promise<UserDetail> {
  const response = await request.get<UserDetail>(
    `${USER_DETAIL_URL}/${userId}`,
    {
      params: {
        ...(expandCertifications ? { expand: 'certifications' } : {}),
      },
    },
  )
  const { data } = response

  return data
}
